import { render, staticRenderFns } from "./PromotionRowNew.vue?vue&type=template&id=9944ffc8&scoped=true"
import script from "./PromotionRowNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromotionRowNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PromotionRowNew.vue?vue&type=style&index=0&id=9944ffc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9944ffc8",
  null
  
)

export default component.exports